import {
  characterActions,
  characterSelectors,
  RaceDefinitionContract,
} from "@dndbeyond/character-rules-engine/es";

import {
  createCharacterActionDescriptor,
  DescribedItem,
} from "../helpers/descriptor";
import type { CharacterActionMapper } from "../middleware";

type RaceChooseAction = ReturnType<typeof characterActions.raceChoose>;

// Same key and name phandalin sends: its species definitionKey and
// useSpecies().getSpeciesName
export const getSpeciesKey = (race: RaceDefinitionContract) =>
  `${race.entityRaceTypeId}:${race.entityRaceId}`;

export const getSpeciesName = (race: RaceDefinitionContract) =>
  race.subRaceShortName
    ? `${race.subRaceShortName} ${race.baseName}`
    : race.baseName || "";

const toItem = (race: RaceDefinitionContract): DescribedItem => ({
  itemId: getSpeciesKey(race),
  name: getSpeciesName(race),
});

/**
 * Choosing a species. Replacing a species is sent as one "change".
 */
export const mapRaceChoose: CharacterActionMapper<RaceChooseAction> = (
  action,
  prevState
) => {
  const { race } = action.payload;
  const previous = characterSelectors.getRace(prevState);

  if (previous && getSpeciesKey(previous) === getSpeciesKey(race)) return null;

  return {
    changeCategory: "SPECIES",
    changeDescriptors: createCharacterActionDescriptor(
      previous ? toItem(previous) : null,
      toItem(race)
    ),
  };
};
